import ApprovalQuestionListItem from '../atoms/ApprovalQuestionListItem';
import React from 'react';

const ApprovalsQuestionsList = (props: any) => {
  const { questionsList, onQuestionSelect, selectedQuestion } = props;
  return (
    <div className="border-l border-[#7b7b7b] h-full">
      {questionsList?.map((item, index) => {
        return (
          <ApprovalQuestionListItem
            key={index}
            title={`Question ${index + 1}`}
            onClick={() => onQuestionSelect(index)}
            active={selectedQuestion === index}
          />
        );
      })}
    </div>
  );
};

export default ApprovalsQuestionsList;
